import { clsx } from 'clsx';
import { Icon } from '../../../../../../icon/Icon';
import styles from './InferSchemaRunning.module.scss';

export function InferSchemaRunning() {
  return (
    <div className='center-flex-row text-medium text-primary' data-id='infer-schema-running'>
      <Icon
        name='testing'
        className={clsx('mr-1', styles.inferSchemaLoader)}
        dataId='infer-schema-running'
      />
      Inferring Object Schema...
    </div>
  );
}
